var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor5',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig,"value":_vm.value || ''},on:{"ready":_vm.onReady,"input":value => _vm.$emit('input', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }